/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 19:09:32
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-06 19:16:48
 * @FilePath: \senlan-ai-ui\src\hooks\useSystemTheme.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { globalAtom, setGlobalStateAtom } from '../stores/global'
/**
 * @description: 暗夜模式切换
 */
const useSystemTheme = () => {
  const [global, setGlobal] = useAtom(globalAtom)
  const [, updateGlobal] = useAtom(setGlobalStateAtom)

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      global.isDarkMode ? 'dark' : 'light'
    )
  }, [global.isDarkMode])
}

export default useSystemTheme
